export const environment = {
    production: true,
    apiEndPoint: 'https://dev-a-api.greatr.com.au/v1/web'
};